import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	pathname: ''
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			case types.UPDATE_PREVIOUS_LOCATION:
				draft.pathname = action.payload.location.pathname;
				return;

			default:
				return state;
		}
	});
